import { Pipe } from '@angular/core';

@Pipe({
    name: 'overseasAddress'
})
export class OverseasAddressPipe {    
    transform(person: any, countryName: string = '') {
        if (!person) {
            return null;
        }
        
        let returnValue = '';
        let delimiter = '';        

        if (person.OverseasAddressLine1) {
            returnValue = person.OverseasAddressLine1;
            delimiter = ", ";
        }
        if (person.OverseasAddressLine2) {
            returnValue = returnValue + delimiter + person.OverseasAddressLine2;
            delimiter = ", ";
        }

        if (person.OverseasSuburbTown) {
            returnValue = returnValue + delimiter + person.OverseasSuburbTown;
            delimiter = ", ";
        }
        if (person.OverseasStateProvinceRegion) {
            returnValue = returnValue + delimiter + person.OverseasStateProvinceRegion;
            delimiter = ", ";
        } 

        if (person.OverseasPostcode) {
            returnValue = returnValue + delimiter + person.OverseasPostcode;
            delimiter = ", ";
        }

      if ((person.OverseasCountryId && !person.OverseasCountryId.startsWith("00000000")) || countryName) {
            returnValue = returnValue + delimiter + (countryName || person.OverseasCountryId);
        }

        return returnValue;
    }
}
